import {TextField} from "@mui/material";
import {t} from "../../../utilities/TranslationUtils";
import {AppSpacer} from "../../../components/ui";
import React from "react";
import AppInfoFrame from "../../../components/ui/AppInfoFrame";

interface ClientInfoDisplayProps {
  id: string,
  secret: string,
  name: string,
  children?: React.ReactNode
}

const ClientInfoDisplay: React.FC<ClientInfoDisplayProps> = (props) => {
  return (
    <div>
      <div className='flex-container'>
        <div className='info-display-container'>
          <TextField
            className="flex-grow"
            variant="filled"
            label={t('clients.identifier')}
            value={props.id}
            InputProps={{
              readOnly: true
            }}
          />
          <AppSpacer space='10px'/>
          <TextField
            className="flex-grow"
            variant="filled"
            label={t('clients.name')}
            value={props.name}
            InputProps={{
              readOnly: true
            }}
          />
          <AppSpacer space='10px'/>
          <TextField
            className="flex-grow"
            variant="filled"
            label={t('clients.secret')}
            value={props.secret}
            InputProps={{
              readOnly: true
            }}
          />
        </div>
      </div>
      <AppSpacer space='20px'/>
      <AppInfoFrame message={t('clients.secretDescription')} className='mb-4 mx-4 mt-0' />
    </div>
  )
}

export default ClientInfoDisplay